import axios from 'axios'
import config from './config.json'
import Swal from 'sweetalert2'
import { authService } from '../services/authService'
// import { useHistory } from 'react-router-dom'
// import { useAuthentication } from '../context/authenticationContext'

// BACKEND NGS
/**
 * AUTHOR : wraudales@ngshn.com 30-6-2022
 * Este JS para conectar al backend con axios sin token....
 */
const URLAPINGS = config.URLBACK2
const key = config.key
const urlfront = key.URLFrontend
const URLCURRENCY = config.URLCurrency
const OcpApimSubscriptionKey = config.OcpApimSubscriptionKey
const accessKey = config.accessKey

// // verificar si el usuario no esta bloqueado
export const postAuthenticated = async () => {
  // Bloqueo de MIPYME

  // const { search } = useLocation()
  const saved = localStorage.getItem('accessToken')

  // const stateQueryParamAT = new URLSearchParams(search).get('accessToken')
  const user = authService.getUserInfo(saved)
  const UserID2C = user?.idUserAzureB2C
  if (UserID2C !== undefined) {
    const TokenBack = localStorage.getItem('TokenBackend')
    const uriAuth = `api/v1/Auth/Authenticated?idUserB2C=${UserID2C}`
    try {
      const { data } = await axios.post(URLAPINGS + uriAuth, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TokenBack}`,
          accessKey: `${config.accessKey}`,
        },
      })

      if (!data.Data.Message) {
        const mensaje = `Contacte con el administrador.`
        Swal.fire({
          title: `El usuario ha sido bloqueado`,
          text: `${mensaje}`,
          icon: 'info',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Entendido',
          allowOutsideClick: false,
          footer:
            '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
        }).then((result) => {
          if (result.isConfirmed) {
            // setisAuthBackend(false)
            localStorage.removeItem('accessToken')
            localStorage.removeItem('TokenBackend')
            window.location.replace(`${urlfront}`)
          }
        })
      }
      // return data
    } catch (error) {
      if (error.response.status === 401) {
        EndOperation()
      } else {
        return error.message
      }
    }
  }
}

export const validateTocken = async () => {
  // Bloqueo de MIPYME

  // const { search } = useLocation()
  const TokenBack = localStorage.getItem('TokenBackend')
  if (TokenBack === null || TokenBack === undefined) {
    const mensaje = `Se ha producido un error de comunicación con nuestro sistema.`

    Swal.fire({
      title: `Ha ocurrido un error`,
      text: `${mensaje}`,
      icon: 'info',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Entendido',
      allowOutsideClick: false,
      footer:
        '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
    })
  }
}

export const CallApiSinToken = {
  // Info de preelegibilidad por proyecto

  getPrelegibilidad: async (uri) => {
    await axios
      .get(URLAPINGS + uri)
      .then((response) => {
        const datosPreElegibilidad = response.data
        return datosPreElegibilidad
      })
      .catch((error) => {
        console.log(error)
      })
  },
  // Mipymes con estado preelegible por IdUserB2c
  //   getMYPYMESById: async (uri) => {
  //     await axios
  //       .get(URLAPINGS + uri)
  //       .then((response) => {
  //         console.log('MIPYME:', response.data)
  //         const datosMipyme = response.data
  //         return datosMipyme
  //       })
  //       .catch((error) => {
  //         console.log(error)
  //       })
  //   },
}

export const getElegibilidad = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}

/**
 * Author: wraudales@ngshn.com
 * 19-7-2022
 * Axios para consumir exclusivamente lo del borrador...
 */
export const getDraftForms = async (uri) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    postAuthenticated()
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get borrador', error)
    }
  }
}

export const CallCurrency = async ({
  SourceCurrencyCode,
  TargetCurrencyCode,
  OriginalAmount,
}) => {
  try {
    // const TokenBack = localStorage.getItem('TokenBackend')
    const uri = `api/public-reference-data-management-x/v1.0/global-standard-specification/currency-exchange/retrieve-by-key?SourceCurrencyCode=${SourceCurrencyCode}&TargetCurrencyCode=${TargetCurrencyCode}&OriginalAmount=${OriginalAmount}`
    const { data } = await axios.get(URLCURRENCY + uri, {
      headers: {
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        accessKey: accessKey,
        // 'Ocp-Apim-Trace': true,
        // Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    console.log('error servicio moneda', error)
  }
}

export const setElegibilityForm = async (uri, form) => {
  validateTocken()
  postAuthenticated()
  const formData = new FormData()
  formData.append('value', JSON.stringify(form))
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.data.Message) {
      Swal.fire({
        title: 'Ocurrió un error al guardar el formulario',
        icon: 'error',
        text: error.response.data.Message.split(':').pop(),
        confirmButtonColor: '#28a745',
        confirmButtonAriaLabelButtonColor: '#d33',
        confirmButtonText: 'Entendido',
      })
    }

    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

export const postLocation = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

export const getLocation = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log(error)
    }
  }
}

export const putElegibidad = async (uri, form) => {
  validateTocken()
  postAuthenticated()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.put(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

export const deleteElegibidad = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.delete(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

export const postElegibilidad = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de IFIS
 * FECHA: 10-8-2022
 */
export const postIFIModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios get para modulo de IFIS
 * FECHA: 15-8-2022
 */
export const getIFIModule = async (uri) => {
  validateTocken()
  postAuthenticated()
  const TokenBack = localStorage.getItem('TokenBackend')
  postAuthenticated()
  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios put para modulo de IFIS
 * FECHA: 15-8-2022
 */
export const putIFIModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.put(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios delete para modulo de IFIS
 * FECHA: 5-9-2022
 */
export const deleteIFIModule = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.delete(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Autenticación de Backend
 * FECHA: 10-8-2022
 */
export const postLogin = async (uri, email, roluser) => {
  const form = {
    FullBearerURL: true,
    ApplicationPassword: key,
    role: roluser,
    Email: email,
  }
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        accessKey: `${config.accessKey}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Autenticación de MIPYME
 * FECHA: 25-9-2022
 */
export const postLoginMipyme = async (uri, email, roluser) => {
  const form = {
    FullBearerURL: true,
    ApplicationPassword: key,
    role: roluser,
    Email: email.eMail,
  }

  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        accessKey: `${config.accessKey}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      const mensaje = error.response.data.message
      Swal.fire({
        title: `¡Error de Solicitud!`,
        text: `${mensaje}`,
        icon: 'info',
        confirmButtonColor: '#28a745',
        // cancelButtonColor: '#d33',

        confirmButtonText: 'Entendido',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
      })
    } else if (
      error.response.data.message
      // 'Usuario esta inactivo favor contactar a la IFI para la activación.'
    ) {
      Swal.fire({
        title: '¡Error!',
        text: `${error.response.data.message}`,
        icon: 'error',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#28a745',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
      })
    } else {
      Swal.fire({
        title: '¡Error!',
        text: 'Ha ocurrido un error al realizar la solicitud.',
        icon: 'error',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#28a745',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
      })
      return error.message
    }
  }
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: validate token
 * FECHA: 26-9-2022
 */
export const postValidate = async (uri, token) => {
  try {
    const { data } = await axios.post(
      URLAPINGS + uri,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
          accessKey: `${config.accessKey}`,
        },
      },
    )
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para descargar el PDF se utiliza fetch para poder utilizar propiedades de convertir a blob
 * FECHA: 13-9-2022
 */
export const getIFIPDF = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  const options = {
    headers: new Headers({
      Authorization: `Bearer ${TokenBack}`,
    }),
  }
  const urlSet = new URL(URLAPINGS + uri)
  // urlSet.search = new URLSearchParams(params).toString()
  return fetch(urlSet, { method: 'GET', ...options })
    .then((res) => {
      if (res.status === 200) {
        return res.blob()
      } else if (res.status === 400) {
        return res.json()
      } else {
        console.log(res)
      }
      if (res.status === 400) {
        return res.json()
      }
      throw new Error(res.text)
    })
    .catch((err) => {
      console.log(err)
    })
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de representar
 * FECHA: 3-10-2022
 */
export const postRepresentationModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    console.log('errr', error.response.data)
    const ErrorB = error.response.data
    if (error.response.status === 401) {
      EndOperation()
    } else {
      if (ErrorB.Code === 500) {
        return error.response.data
      } else {
        return error.response.data
      }
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios get para modulo de representar
 * FECHA: 3-10-2022
 */
export const getRepresentationModule = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios put para modulo de representar
 * FECHA: 3-10-2022
 */
export const putRepresentationModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.put(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios delete para modulo de representar
 * FECHA: 3-10-2022
 */
export const deleteRepresentationModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.delete(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * Author: wraudales@ngshn.com
 * DESCRIPTION: CREAR MIPYME Externo
 * Fecha: 10-10-2022
 */
export const createUserMIPYME = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * Author: wraudales@ngshn.com
 * DESCRIPTION: El status del usuario
 * Fecha: 3-11-2022
 */

export const getUserStatus = async (uri, TokenBack) => {
  // const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log(error)
    }
  }
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de workshop
 * FECHA: 23-11-2022
 */
export const postWorkshopModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios get para modulo de workshop
 * FECHA: 23-11-2022
 */
export const getWorkshopModule = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios put para modulo de Workshop
 * FECHA: 23-11-2022
 */
export const putWorkshopModule = async (uri, form) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.put(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios delete para modulo de Workshop
 * FECHA: 23-11-2022
 */
export const deleteWorkshopModule = async (uri) => {
  validateTocken()
  postAuthenticated()

  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.delete(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

// Funcion de vencimiento de Token....

const EndOperation = () => {
  // const history = useHistory()

  Swal.fire({
    title: 'Error de Autenticación',
    text: 'Su sesión ha finalizado, por favor vuelva a ingresar al sistema.',
    icon: 'error',
  })
  localStorage.removeItem('accessToken')
  localStorage.removeItem('TokenBackend')
  window.location.replace(`${urlfront}`)
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios get para modulo de asistencia tecnica
 * FECHA: 20-01-2023
 */
export const getTechnicalAssistanceModule = async (uri) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de asistencia tecnica
 * FECHA: 20-01-2023
 */
export const postTechnicalAssistanceModule = async (uri, form) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios delete para modulo de Asistencia Tecnica
 * FECHA: 01-02-2023
 */
export const deleteTechnicalAssistanceModule = async (uri) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.delete(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios put para modulo de Asistencia Tecnica
 * FECHA: 03-02-2023
 */
export const putTechnicalAssistanceModule = async (uri, form) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.put(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios get para modulo de  Monitoreo y Evaluacion
 * FECHA: 23-10-2023
 */
export const getMonotoringAndEvaluationModule = async (uri) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.get(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })

    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      console.log('error desde el get', error)
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de monitoreo y evaluacion
 * FECHA: 24-10-2023
 */
export const setMonotoringAndEvaluationModule = async (uri, form) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.data.Message) {
      Swal.fire({
        title: 'Ocurrió un error al guardar el formulario',
        icon: 'error',
        text: error.response.data.Message.split(':').pop(),
        confirmButtonColor: '#28a745',
        confirmButtonAriaLabelButtonColor: '#d33',
        confirmButtonText: 'Entendido',
      })
    }
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios post para modulo de monitoreo y evaluacion
 * FECHA: 24-10-2023
 */
export const postMonotoringAndEvaluationModule = async (uri, form) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')
  try {
    const { data } = await axios.post(URLAPINGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Endpoint para consumir servicios put para modulo de monitoreo y evaluacion
 * FECHA: 7-2-2024
 */
export const deleteMonotoringAndEvaluationModule = async (uri) => {
  validateTocken()
  const TokenBack = localStorage.getItem('TokenBackend')

  try {
    const { data } = await axios.delete(URLAPINGS + uri, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      },
    })
    return data
  } catch (error) {
    if (error.response.status === 401) {
      EndOperation()
    } else {
      return error.message
    }
  }
}
